import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';

import noop from 'lodash/noop';

import Entity, { getElement, getType } from './entity';
import Categories from './categories';
import { getFiles, downloadZip, downloadFile } from './utils';

lessRequire('modules/offers/components/promo-gallery/gallery.less');

const propTypes = {
	showedFileIndex: PropTypes.number,
	promoFilesList: PropTypes.object,
	categories: PropTypes.array,
	currentCategory: PropTypes.string,
	title: PropTypes.string,
	downloadTitle: PropTypes.string,
	zipFilesSize: PropTypes.number
};

class Gallery extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showedFileIndex: this.props.showedFileIndex,
			currentCategory: this.props.currentCategory,
			thumbnailsWrapperWidth: 0,
			thumbsTranslate: 0
		};
	}

	componentDidMount() {
		const perIndexScroll = this.getThumbnailPerIndexScrollWidth(this.state.showedFileIndex);
		this.setState({
			thumbsTranslate: this.state.thumbsTranslate - perIndexScroll
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.showedFileIndex !== this.state.showedFileIndex) {
			const indexDifference = Math.abs(prevState.showedFileIndex - this.state.showedFileIndex);
			const perIndexScroll = this.getThumbnailPerIndexScrollWidth(indexDifference);

			if (perIndexScroll > 0) {
				if (prevState.showedFileIndex < this.state.showedFileIndex) {
					this.setState({ thumbsTranslate: this.state.thumbsTranslate - perIndexScroll });
				} else if (prevState.showedFileIndex > this.state.showedFileIndex) {
					this.setState({ thumbsTranslate: this.state.thumbsTranslate + perIndexScroll });
				}
			}

		}
	}

	navigation(duration) {
		const lastIndex = (this.getFilesByCategory()).length - 1;
		const currentIndex = this.state.showedFileIndex;

		if (duration === 'prev') {
			if (currentIndex === 0 ) return this.previewByIndex(lastIndex);
			this.previewByIndex(currentIndex - 1);
		}

		if (duration === 'next') {
			if (currentIndex === lastIndex ) return this.previewByIndex(0);
			this.previewByIndex(currentIndex + 1);
		}

		this.setState({
			shouldAnimatePreview: !this.state.shouldAnimatePreview
		});

	}

	previewByIndex(index) {
		this.setState((prevState, props) => ({
			showedFileIndex: index
		}));
	}

	getThumbnailPerIndexScrollWidth(indexDifference) {
		const thumbnailsWrapperWidth = this._thumbnailsWrapper.offsetWidth;
		const thumbnailsScrollWidth = this._thumbnails.scrollWidth;
		const totalThumbnails = this._thumbnails.childNodes.length;
		const totalScroll = thumbnailsScrollWidth - thumbnailsWrapperWidth;

		return (totalScroll / (totalThumbnails - 1)) * indexDifference;
	}

	getThumbnailTranslateStyle() {
		const translate = `translate(${this.state.thumbsTranslate}px, 0)`;

		return {
			WebkitTransform: translate,
			MozTransform: translate,
			msTransform: translate,
			OTransform: translate,
			transform: translate
		};
	}

	getFilesByCategory() {
		return this.props.promoFilesList[this.state.currentCategory];
	}

	changeCategory(categoryId) {
		this.setState({
			currentCategory: categoryId,
			showedFileIndex: 0,
			thumbsTranslate: 0
		});
	}

	download(file) {
		const fileName = file.split('/').pop();
		downloadFile(file, fileName);
	}

	render() {
		const previewFile = (this.getFilesByCategory())[this.state.showedFileIndex];
		const translate = this.getThumbnailTranslateStyle();
		const openImage = src => (window.open(src, '_blank')).focus();
		return (
			<div className="offer-promo-gallery">
				<div className="offer-promo-gallery--head">
					<div className="offer-promo-gallery--head-position">
						<h2 className="font-proxima-nova-bold">{this.props.title}</h2>
					</div>
					<div className="offer-promo-gallery--head-position position--categories">
						{ this.props.categories.length > 1 && (
							<Categories
								categories={this.props.categories}
								currentCategory={this.state.currentCategory}
								onSelect={id => this.changeCategory.call(this, id)}/>
						) }
					</div>
				</div>
				<div className="offer-promo-gallery--view">
					<div
						onClick={() => getType(previewFile) === 'img' ? openImage(previewFile): noop() }
						className='offer-promo-gallery--view__item'>
						{ getElement(previewFile) }
						<span
							onClick={ e => { e.stopPropagation(); this.download(previewFile); }  }
							className="offer-promo-gallery--view__item-download" />
					</div>
					<span
						onClick={this.navigation.bind(this, 'prev')}
						className="offer-promo-gallery-nav offer-promo-gallery-nav--left" />
					<span
						onClick={this.navigation.bind(this, 'next')}
						className="offer-promo-gallery-nav offer-promo-gallery-nav--right" />
				</div>
				<div
					ref={el => this._thumbnailsWrapper = el}
					className="offer-promo-gallery--thumbs">
					<div
						style={translate}
						ref={el => this._thumbnails = el}
						className="offer-promo-gallery--thumbs__items">
						{ (this.getFilesByCategory()).map((file, index) => (
							<Entity
								src={file}
								key={index}
								index={index}
								onClickAction={this.previewByIndex.bind(this)}
								activeClassName={this.state.showedFileIndex === index && 'promo-thumb--border'} />
						)) }
					</div>
				</div>

				<a
					onClick={() => downloadZip(getFiles(this.props.promoFilesList))}
					href="javascript:;"
					className="offer-promo-download">{`${this.props.downloadTitle}, ${this.props.zipFilesSize} Mb`}</a>

			</div>
		);
	}
}

Gallery.propTypes = propTypes;
export default Gallery;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/promo-gallery/gallery.js